import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import { useFormsApplicationsStore } from "../_store/useFormsApplications.store";
import {
  FormsApplicationsMeta,
  FormsApplicationsQueryData,
} from "../_types/formsApplications.types";

const FALLBACK_META: FormsApplicationsMeta = {
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

export const useFormsApplicationsQuery = () => {
  const type = useFormsApplicationsStore((state) => state.type);
  const period = useFormsApplicationsStore((state) => state.period);
  const status = useFormsApplicationsStore((state) => state.status);
  const search = useFormsApplicationsStore((state) => state.search);
  const page = useFormsApplicationsStore((state) => state.page);
  const limit = useFormsApplicationsStore((state) => state.limit);
  const [searchDebounced, setSearchDebounced] = useState(search);

  useEffect(() => {
    const timeout = setTimeout(() => setSearchDebounced(search.trim()), 300);
    return () => clearTimeout(timeout);
  }, [search]);

  return useQuery({
    queryKey: ["forms-applications", type, period, status, searchDebounced, page, limit],
    queryFn: async (): Promise<FormsApplicationsQueryData> => {
      const response = await axiosInstance.get<
        ApiResponse<FormsApplicationsQueryData["items"], FormsApplicationsMeta>
      >("/v2/inbox/forms/applications", {
        params: {
          type,
          period,
          status,
          ...(searchDebounced.length > 0 ? { q: searchDebounced } : {}),
          page,
          limit,
        },
      });

      return {
        items: response.data.data ?? [],
        meta: response.data.meta ?? {
          ...FALLBACK_META,
          page,
          limit,
        },
      };
    },
    placeholderData: (previousData) => previousData,
  });
};
